import { call, put, takeLatest } from 'redux-saga/effects';
import { DeviceGroupMap } from 'types';
import { deviceGroupsLoadSuccess, deviceGroupsLoadFailure } from 'actions/deviceGroupActions';
import { getDeviceGroups } from 'api';
import { handleErrorSaga } from 'sagas/app/handleError';


export function* loadDeviceGroupsRequestWatcher() {
    yield takeLatest('DEVICEGROUPS_LOAD_REQUEST', loadDeviceGroupsSaga);
}

export function* loadDeviceGroupsSaga() {
    let deviceGroups: DeviceGroupMap;
    try {
        deviceGroups = yield call(getDeviceGroups);
    }
    catch (err) {
        yield call(handleErrorSaga, err, deviceGroupsLoadFailure);
        return;
    }
    yield put(deviceGroupsLoadSuccess(deviceGroups));
}



// WEBPACK FOOTER //
// ./src/sagas/deviceGroups/loadDeviceGroupsSaga.ts